module.exports = __webpack_public_path__ + "static/media/heavy-breather.b86a4603.jpg";